module.exports = __webpack_public_path__ + "14_ldav.png?167b7ea3f5788383f017996cf9d72d81";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/14_ldav.png
// module id = 153
// module chunks = 0